import {createAsyncThunk} from "@reduxjs/toolkit";
import request from "../../../../service";
import {IErrorResponse, IRootState} from "../../../../types";
import {ICreateUnitedGroupsSubject, IEditUnitedLessonsCategories, IUnitedCreate, IUnitedPayload} from "../types";
import {
    deletedRestoreUnited,
    deletedUnited,
    setRestoreUnited,
    setUnited, setUnitedLessonsCategories, setUniteLessonsGroups,
    updateUnited
} from "../store/unitedLessonsSlice";
import {setSubjectsData} from "@pages/EducationalStructure/Subject/store/subjectSlice";



const CreateUnited = createAsyncThunk(
    "create/united",
    async (payload: IUnitedCreate, {rejectWithValue}) => {
        try {
            const response = await request.post("/united-lessons", payload);

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


const GetUnited = createAsyncThunk(
    "get/united",
    async (_,{rejectWithValue,dispatch}) => {
        try {
            const response = await request.get("/united-lessons");
            dispatch(setUnited(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const DeleteUnited= createAsyncThunk(
    "delete/united",
    async (id:number, { dispatch,rejectWithValue }) => {
        try {
            const response = await request.delete(`/united-lessons/${id}`);
            dispatch(deletedUnited(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


const EditUnited= createAsyncThunk(
    "edit/united",
    async ( data :IUnitedPayload, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/united-lessons/${data.id}`, data);
            dispatch(updateUnited(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetDeleteUnited= createAsyncThunk(
    "get/delete/united",
    async (_,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.get(`/united-lessons/deleted-items`);
            dispatch(setRestoreUnited(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);
const RestoreDeleteUnited = createAsyncThunk(
    "restore/delete/united",
    async (id:number,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.post(`/united-lessons/restore/${id}`);
            dispatch(deletedRestoreUnited(id));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


const UnitedLessonsCategoriesItem = createAsyncThunk(
    "united/lessons/categories/item",
    async (unitedLessonsId: number, { rejectWithValue,dispatch }) => {
        try {
            const response = await request.get(`/united-lessons-categories/${unitedLessonsId}`);
                dispatch(setUnitedLessonsCategories(response.data));
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response?.data?.message || "unexpected_fail");
        }
    }
);


const CreateUnitedGroupsSubject = createAsyncThunk(
    "create/united/groups/subject/",
    async (data: ICreateUnitedGroupsSubject, { rejectWithValue }) => {
        try {
            const response = await request.post(
                `/united-groups/create/${data.id}`,
                {
                    subject_ids: data.subject_ids,
                    child_subject_ids: data.child_subject_ids,
                }
            );
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response?.data?.message || "unexpected_fail");
        }
    }
);



const GetUnitedLessonSubject = createAsyncThunk(
    "get/united-lessons/subject/",
    async (id: number, { rejectWithValue,dispatch,getState }) => {
        try {
            const response = await request.get(`/united-lessons/${id}/subjects/`);
            const lang = getState()  as IRootState
            const defaultLanguage = lang.languages.defaultLanguage
            dispatch(setSubjectsData({ data: response.data.subjects,defaultLanguage }));
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response?.data?.message || "unexpected_fail");
        }
    }
)

const GetUnitedLessonGroups = createAsyncThunk(
    "get/united-lessons/subject/",
    async (id: number, { rejectWithValue,dispatch,getState }) => {
        try {
            const lang = getState()  as IRootState
            const defaultLanguage = lang.languages.defaultLanguage
            const response = await request.get(`/united-lessons/${id}/groups/`);
            dispatch(setUniteLessonsGroups({data:response.data,defaultLanguage}))

        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response?.data?.message || "unexpected_fail");
        }
    }
)


const CreateUnitedLessonsCategories = createAsyncThunk(
    "create/united-lessons/categories/",
    async (data: any, { rejectWithValue }) => {
        try {
           return await request.post("united-lessons-categories",data);
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response?.data?.message || "unexpected_fail");
        }
    }
)


const DeleteUnitedLessonsCategories = createAsyncThunk(
    "delete/united-lessons/categories/",
    async (id: number, { rejectWithValue }) => {
        try {
            return await request.delete(`united-lessons-categories/${id}`);
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response?.data?.message || "unexpected_fail");
        }
    }
)

const EditUnitedLessonsCategories = createAsyncThunk(
    "edit/united-lessons/categories/",
    async (data: IEditUnitedLessonsCategories, { rejectWithValue }) => {
        try {
            return await request.put(`united-lessons-categories/${data.id}`,data);
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response?.data?.message || "unexpected_fail");
        }
    }
)



export{
    CreateUnited,
    GetUnited,
    DeleteUnited,
    EditUnited,
    GetDeleteUnited,
    RestoreDeleteUnited,
    UnitedLessonsCategoriesItem,
    CreateUnitedGroupsSubject,
    GetUnitedLessonSubject,
    GetUnitedLessonGroups,
    CreateUnitedLessonsCategories,
    DeleteUnitedLessonsCategories,
    EditUnitedLessonsCategories
}